$(function() {

    //migrate from 'live' to 'on' to support yiigridview
    jQuery.fn.extend({
        live: function( types, data, fn ) {
            jQuery( this.context ).on( types, this.selector, data, fn );
            return this;
        }
    });

    $('#dyn a.delete').on('click', function () {
        if(!confirm('Вы действительно хотите удалить этот элемент?')) return false;
    });


    //===== Notification boxes =====//

    $(".nNote").click(function() {
        $(this).fadeTo(200, 0.00, function(){ //fade
            $(this).slideUp(200, function() { //slide up
                $(this).remove(); //then remove from the DOM
            });
        });
    });


    //===== Animate current li when closing button clicked =====//

    $(".remove").click(function() {
        $(this).parent('li').fadeTo(200, 0.00, function(){ //fade
            $(this).slideUp(200, function() { //slide up
                $(this).remove(); //then remove from the DOM
            });
        });
    });



    //===== Check all checbboxes =====//

    $(".titleIcon input:checkbox").click(function() {
        var checkedStatus = this.checked;
        $(".checkAll tbody tr td:first-child input:checkbox").each(function() {
            this.checked = checkedStatus;
            if (checkedStatus == this.checked) {
                $(this).closest('.uniform-checker span').removeClass('checked');
                $(this).closest('table tbody tr').removeClass('thisRow');
            }
            if (this.checked) {
                $(this).closest('.uniform-checker span').addClass('checked');
                $(this).closest('table tbody tr').addClass('thisRow');
            }
            if($('.search_order').hasClass('active_search')) {

                if($('#Order_status_id option:selected').val()) {

                    $('.change_status_for_group').show();

                    if($('.check_order_id span.checked input').length == 0){
                        $('.change_status_for_group').hide();
                    }

                } else {
                    $('.change_status_for_group').hide();
                }

            }
        });
    });

    $(function() {
        $('.checkAll tbody tr td:first-child input[type=checkbox]').change(function() {
            $(this).closest('tr').toggleClass("thisRow", this.checked);
        });
    });


    //===== Sparklines =====//

    $('.balBars').sparkline('html', {
        type: 'bar',
        height: 25,
        stackedBarColor: ['#009AD6','#f65f5f'],
        barWidth: 8,
        barColor: '#009AD6',
        disableTooltips: true
    });


    //===== Top panel search field =====//

    $('.userNav a.search').click(function () {
        $('.topSearch').fadeToggle(150);
    });

    //===== Dynamic table toolbars =====//

    $('#dyn .tOptions').click(function () {
        $('#dyn .tablePars').slideToggle(200);
    });

    $('#dyn2 .tOptions').click(function () {
        $('#dyn2 .tablePars').slideToggle(200);
    });


    $('.tOptions').click(function () {
        $(this).toggleClass("act");
    });

    //===== Vertical sliders =====//

    $( "#eq > span" ).each(function() {
        // read initial values from markup and remove that
        var value = parseInt( $( this ).text(), 10 );
        $( this ).empty().slider({
            value: value,
            range: "min",
            animate: true,
            orientation: "vertical"
        });
    });


    //===== Modal =====//

    $('#dialog-modal').dialog({
        autoOpen: false,
        width: 500,
        height: 500,
        modal: true
    });

    $('#modal_open').click(function () {
        $('#dialog-modal').dialog('open');
        return false;
    });


    //===== jQuery UI stuff =====//


    // Modal Link
    $('#modal_link').click(function () {
        $('#dialog-message').dialog('open');
        return false;
    });

    $(function() {
        var dates = $( "#fromDate, #toDate" ).datepicker({
            defaultDate: "+1w",
            changeMonth: false,
            showOtherMonths:true,
            numberOfMonths: 3,
            onSelect: function( selectedDate ) {
                var option = this.id == "fromDate" ? "minDate" : "maxDate",
                    instance = $( this ).data( "datepicker" ),
                    date = $.datepicker.parseDate(
                        instance.settings.dateFormat ||
                        $.datepicker._defaults.dateFormat,
                        selectedDate, instance.settings );
                dates.not( this ).datepicker( "option", option, date );
            }
        });
    });


    //===== Add class on #content resize. Needed for responsive grid =====//

    $('#content').resize(function () {
        var width = $(this).width();
        if (width < 769) {
            $(this).addClass('under');
        }
        else { $(this).removeClass('under') }
    }).resize(); // Run resize on window load


    //===== Button for showing up sidebar on iPad portrait mode. Appears on right top =====//

    $("ul.userNav li a.sidebar").click(function() {
        $(".secNav").toggleClass('display');
    });


    //===== Form elements styling =====//

    $(".check, .check :checkbox, input:radio, input:file").uniform();




    //======My Product Tree========/

    $('.product_category').click(function(){
        $('.parent_' + $(this).attr('id')).slideToggle();
        $('.' + $(this).attr('id')).slideToggle();
        $(this).find('.icos-arrowright').toggle();
        $(this).find('.icos-arrowdown').toggle();
    });

    $('.product_tree').click(function(){
        $('.parent_' + $(this).attr('id')).toggle();
        var toggleElement = $('.' + $(this).attr('id')),
            parentToggleElement = $('.parent_' + $(this).attr('id'));

        if (parentToggleElement.css('display') == 'block') {
            parentToggleElement.css('display', 'table-row');
        }

        if (toggleElement.css('display') == 'none') {
            toggleElement.css('display', 'table-row');
        } else {
            toggleElement.css('display', 'none');
        }
        $('.parent_item_' + $(this).attr('id')).hide();
    });


    /******* product pre upload *********/

    /******* product pre upload on complaint page **********/

    $('#Complaint_product_id').change(function(){

        $.get($('.base_url').attr('href') + '/order/product?id=' + $('#Complaint_product_id option:selected').val(), function(response){

            $('.span_profile_length').html('');
            $('.span_product_length').html('');

            var product = $.parseJSON(response);

            var height = - parseInt($('.image_box').css('height')) - 20;

            if(product.product.image_name != null){
                $('.product_image.compare img').attr('src', $('.base_url').attr('href') + '/data/products/' + product.product.image_name).attr('alt', product.product.product_name);
                $('.product_image.compare').show(500);
                if(parseInt($('.product_image.compare img').css('height')) > 0){
                    height = height + parseInt($('.product_image.compare img').css('height')) + 15;
                }
            }else{
                $('.product_image.compare img').attr('src', '');
                $('.product_image.compare').hide(500);
            }

            if(product.product.have_coef == 1){
                $('.order_image .scheme.compare').slideUp();
                $('.title_order_image.compare').slideDown();
                $('.product_image.compare').css('top', 22);
                height = height + 22;

            }else{
                $('.order_image .scheme.compare').slideDown();
                $('.title_order_image.compare').slideUp();
                $('.product_image.compare').css('top', 250);
                height = height + 250;
            }

            if(height > 0)
                $('.set_height_div').css('height', height).show();
            else{
                $('.set_height_div').hide();
            }

        });
    });


    if($('#Complaint_product_id option:selected').val() > 0){
        $.get($('.base_url').attr('href') + '/order/product?id=' + $('#Complaint_product_id option:selected').val(), function(response){

            $('.span_profile_length').html('');
            $('.span_product_length').html('');

            var product = $.parseJSON(response);

            var height = - parseInt($('.image_box').css('height')) - 20;

            if(product.product.image_name != null){
                $('.product_image.compare img').attr('src', $('.base_url').attr('href') + '/data/products/' + product.product.image_name).attr('alt', product.product.product_name);
                $('.product_image.compare').show(500);
                if(parseInt($('.product_image.compare img').css('height')) > 0){
                    height = height + parseInt($('.product_image.compare img').css('height')) + 15;
                }
            }else{
                $('.product_image.compare img').attr('src', '');
                $('.product_image.compare').hide(500);
            }

            if(product.product.have_coef == 1){
                $('.order_image .scheme.compare').slideUp();
                $('.title_order_image.compare').slideDown();
                $('.product_image.compare').css('top', 22);
                height = height + 22;

            }else{
                $('.order_image .scheme.compare').slideDown();
                $('.title_order_image.compare').slideUp();
                $('.product_image.compare').css('top', 250);
                height = height + 250;
            }

            if(height > 0)
                $('.set_height_div').css('height', height).show();
            else{
                $('.set_height_div').hide();
            }

        });
    }


    /************ statuses ************/

    var originalContent;


    $('.select-on-check').change(function(){

        if($('.search_order').hasClass('active_search')) {

            if($('#Order_status_id option:selected').val()) {

                $('.change_status_for_group').show();

                if($('.check_order_id span.checked input').length == 0){
                    $('.change_status_for_group').hide();
                }

            } else {
                $('.change_status_for_group').hide();
            }

        }

    });


    /************ /statuses ************/


    $('#dialog-client-import').dialog({
        autoOpen: false,
        width: 350,
        modal: true,
        buttons: {
            "Загрузить": function() {
                $('#import-client-form').submit();
            },
            "Отмена": function() {
                $(this).dialog('close');
            }
        }
    });

    $('#dialog-product-import').dialog({
        autoOpen: false,
        width: 350,
        modal: true,
        buttons: {
            "Загрузить": function() {
                $('#import-product-form').submit();
            },
            "Отмена": function() {
                $(this).dialog('close');
            }
        }
    });

    $('#dialog-material-import').dialog({
        autoOpen: false,
        width: 350,
        modal: true,
        buttons: {
            "Загрузить": function() {
                $('#import-material-form').submit();
            },
            "Отмена": function() {
                $(this).dialog('close');
            }
        }
    });

    $('#dialog-files').dialog({
        autoOpen: false,
        width: 450,
        modal: true,
        buttons: {
            "Отмена": function() {
                $(this).dialog('close');
            }
        }
    });

    $('body').on('click', '.view_files', function(){
        $.get($(this).attr('href'), function(result){
            if(xtractFile(result) != false){
                window.open(result, '_blank');
                return false;
            }
            $('#dialog-files').html(result);
            // $("#dialog-files input.form_field").uniform();
            $('#dialog-files').dialog('open');
        });
        return false;
    });


    $('.product_import').click(function(){
        $('#dialog-product-import').dialog('open');
    });

    $('.material_import').click(function(){
        $('#dialog-material-import').dialog('open');
    });

    $('.client_import').click(function(){
        $('#dialog-client-import').dialog('open');
    });


    $('.client_export').click(function(){
        var client_checked = $('.check_client_id input:checked');

        if(client_checked.length == 0){
            if(confirm('Внимание! Вы не выбрали ни одного клиента. Зделать експорт всех клиентов?')){
                window.open($('.base_url').attr('href') + '/client/export', '_blank');
            }
            return false;

        }else{
            if(confirm('Сделать экспорт выделенных клиентов?')){
                var export_url = $('.base_url').attr('href') + '/client/export?Client[ids]='
                $.each(client_checked, function(index, order){
                    export_url += order.value;
                    if(index + 1 != client_checked.length){
                        export_url += ',';
                    }
                });

                window.open(export_url, '_blank');
            }
        }
    });

    function getLaboriousness(open) {
        var url = $('.base_url').attr('href') + '/order/getLaboriousness';

        var searchParams = '';
        var delimiter = '?';
        var order_checked = $('.check_order_id span.checked input');
        if(order_checked.length > 0){
            delimiter='&';
            searchParams += '?Order[ids]=';
            $.each(order_checked, function(index, order){
                searchParams += order.value;
                if(index + 1 != order_checked.length){
                    searchParams += ',';
                }
            });
        };
        var brigades = JSON.parse(localStorage.laboriousnessBrigade ? 
            localStorage.getItem('laboriousnessBrigade') : '[]');
        if (brigades.length > 0) {
            searchParams += delimiter + 'Brigade[ids]=' + brigades;
        };

        $.get(url+searchParams, function(result){
            $('#dialog-lab-sum span.message').html(result);
            if (open) {
                $('#dialog-lab-sum').dialog('open');
            }
        });
    };

    $('.laboriousness').click(function(){
        getLaboriousness(true);
    });

    $(document).on('change', '#laboriousnessBrigade input[type=checkbox]', function (event) {
        var brigades = [];
        event.target.closest('#laboriousnessBrigade').querySelectorAll(':checked').forEach(function (item) { 
            brigades.push(item.value) 
        });

        localStorage.setItem('laboriousnessBrigade', JSON.stringify(brigades));
        getLaboriousness(false)
    });

    $('#dialog-change-causes-of-claim').dialog({
        autoOpen: false,
        width: 400,
        modal: true,
        buttons: {
            "Сохранить": function(){
                $("#change-causes-of-claim-form").uniform();
                $('#change-causes-of-claim-form').submit();
            },
            "Отмена": function() {
                $(this).dialog('close');
            }
        }
    });

    $('.change_causes_of_claim').click(function(){
        $('#dialog-change-causes-of-claim').dialog('open');
    });


    $('#orderPaginateSize').change(function(){
        $('#order-search-form').submit();
    });

});

function roundPlus(x, n) {
    if(isNaN(x) || isNaN(n)) return false;
    var m = Math.pow(10,n);
    return Math.round(x*m)/m;
}


function floatval(mixed_var) {
    return (parseFloat(mixed_var) || 0);
}

function intval( mixed_var, base ) {
    var tmp;

    if( typeof( mixed_var ) == 'string' ){
        tmp = parseInt(mixed_var);
        if(isNaN(tmp)){
            return 0;
        } else{
            return tmp.toString(base || 10);
        }
    } else if( typeof( mixed_var ) == 'number' ){
        return Math.floor(mixed_var);
    } else{
        return 0;
    }
}

function xtractFile(data){
    var m = data.match(/(.*)[\/\\]([^\/\\]+\.\w+)$/);
    if(m == null){
        return false;
    }
    return {path: m[1], file: m[2]}
}

function IsNumeric(input)
{
    return (input - 0) == input && input.length > 0;
}

function getOrderId(url){
    var id = [];
    var a = $('<a>',{href:url})[0];
    var query = a.search;
    var queryString = query.substring(1);
    var queries = queryString.split("&");
    for (var i = 0, l = queries.length; i < l; i++ ) {
        var temp = queries[i].split('=');
        if(temp[0] === 'id'){
            id.push(temp[1]);
        }
    }
    return id;
}

function getOrderIds(checkboxesToFing){
    var checkboxes = checkboxesToFing || '.check_order_id span.checked input';
    var ids = [];
    var client_checked = $(checkboxes);
    $.each(client_checked, function(index, order){
        ids.push(order.value);
    });
    return ids;
}

function updateRow(id, ids){
    var rowsToUpdate = {};
    if(id.length > 0){
        rowsToUpdate[id] = $('.check_order_id input[value='+id+']').closest('tr');
    } else if(ids.length > 0){
        for(var i=0; i < ids.length; i++){
            rowsToUpdate[ids[i]] = $('.check_order_id input[value='+ids[i]+']').closest('tr');
        }
    }
    $.each(rowsToUpdate, function(key){
        if(rowsToUpdate.hasOwnProperty(key)){
            $.when(
                $.ajax({
                    type: 'GET',
                    data: {
                        id: key,
                        is_suborder: (rowsToUpdate[key].closest('#dialog-suborders').length ? true : false)
                    },
                    url: $('.base_url').attr('href') + '/order/row',
                    async:  false
                })
            ).then(function(response){
                    var dataT = $('tbody tr',$(response.split('class="grid-view">')[1]));
                    var row = rowsToUpdate[key];
                    row.html(dataT.html());
                    var number = (Math.ceil(Math.random() * 200)+ 100);
                    row.find('.select-on-check').wrap("<div id='uniform-checkboxHeader_"+ number + "' class='uniform-checker checker'><span class=''></span></div>");
                    row.find('.select-on-check').attr('id', 'checkboxHeader_'+number);
                    row.find('.days_left_to_order').each(function(){
                        switch($(this).html()){
                            case '7':
                                $(this).css('background', localStorage.getItem('color_day_7'));
                                break;
                            case '6':
                                $(this).css('background', localStorage.getItem('color_day_6'));
                                break;
                            case '5':
                                $(this).css('background', localStorage.getItem('color_day_5'));
                                break;
                            case '4':
                                $(this).css('background', localStorage.getItem('color_day_4'));
                                break;
                            case '3':
                                $(this).css('background', localStorage.getItem('color_day_3'));
                                break;
                            case '2':
                                $(this).css('background', localStorage.getItem('color_day_2'));
                                break;
                            case '1':
                                $(this).css('background', localStorage.getItem('color_day_1'));
                                break;
                            case '0':
                                $(this).css('background', localStorage.getItem('color_day_0'));
                                break;
                            case 'заказ просрочен':
                                $(this).css('background', localStorage.getItem('color_day_expired'));
                                break;
                        }
                        if(~~$(this).html() > 7){
                            $(this).css('background', localStorage.getItem('color_day_over_7'));
                        }
                    });
                    var template = /\{.*\}/g;
                    var flash = response.match(template);
                    if(flash){
                        var obj = JSON.parse(flash[0]);
                        if(obj.success){
                            alert(obj.success);
                        } else if(obj.error){
                            alert(obj.error);
                        }else if(obj.errorReturn){
                            alert(obj.errorReturn);
                            var url = $('.base_url').attr('href') + '/order/status';
                            var data = {'Order' : {id: id[0], status_id: 3}};
                            $.post(url, data, function(){
                                updateRow(id, ids);
                            });
                        }
                    }
                    $(".ui-dialog-content:not(#dialog-suborders)").dialog("close");
                }
            );
        }
    });
}

function setProductComplaint(id, title){
    $("#Complaint_product_id").val(id).trigger("change");
    $('#Complaint_product_id_chzn .chzn-single span').html(title);
    $('#dialog-modal').dialog('close');
    $('.product_item').removeClass('selected');
    $('.product_' + id).addClass('selected');
}


function setProduct(id, title){
    $("#Order_product_id").val(id).trigger("change");
    $('#Order_product_id_chzn .chzn-single span').html(title);
    $('#dialog-modal').dialog('close');
    $('.product_item').removeClass('selected');
    $('.product_' + id).addClass('selected');
}

function roundPlus(x, n) { //x - число, n - количество знаков
    if(isNaN(x) || isNaN(n)) return false;
    var m = Math.pow(10,n);
    return Math.round(x*m)/m;
}

function attachProductData(product){
    var $hiddenField = $('#hidden-product-data');
    if($hiddenField.length == 0){
        $('<input>').attr({
            type: 'hidden',
            id:'hidden-product-data',
            'data-json': product
        }).appendTo($('#order-form'));
    } else {
        $hiddenField.attr('data-json', product);
    }
}

function checkCourierCompany(val) {
    $userGroup = $('#user_group_id').val();
    if(val == 81){
        $.uniform.update($("#Order_cargo_payer input[type=radio]").prop("checked", false));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=1]").attr("disabled", true));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=3]").attr("disabled", true));
        //Исключаем выбор для групп партнеры и партнеры эксперт
        if ($userGroup==6 || $userGroup==11) {
            $.uniform.update($("#Order_cargo_payer input[type=radio][value=2]").attr("disabled", true));
        } else {
            $.uniform.update($("#Order_cargo_payer input[type=radio][value=2]").attr("checked", true));
        }
    } else if (val == 5 || val == 8) { //Деловые линии и байкал сервис
        var cargoConsignee = $('#Order_change_cargo_consignee').prop('checked');

        $.uniform.update($("#Order_cargo_payer input[type=radio][value=1]").attr("disabled", false));
        //Исключаем выбор для групп партнеры и партнеры эксперт
        if ($userGroup==6 || $userGroup==11) {
            $.uniform.update($("#Order_cargo_payer input[type=radio][value=2]").attr("disabled", true));
        } else {
            $.uniform.update($("#Order_cargo_payer input[type=radio][value=2]").attr("disabled", false));
        }

        $.uniform.update($("#Order_cargo_payer input[type=radio][value=3]").attr("disabled", !cargoConsignee));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=1]").prop("checked", true));
    } else {
        var initialCargoPayer = $("#initialCargoPayer").val();
        initialCargoPayer = $.inArray(initialCargoPayer, [1, 3]) ? initialCargoPayer : 1;
        $.uniform.update($("#Order_cargo_payer input[type=radio]").attr("checked", false));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=1]").attr("disabled", false));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=3]").attr("disabled", false));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value=2]").attr("disabled", true));
        $.uniform.update($("#Order_cargo_payer input[type=radio][value="+initialCargoPayer+"]").prop("checked", true));
    }
}

var width_first_level = 0;
var width_second_level = 0;
var height_first_level = 0;
var height_second_level = 0;
var initial_inside_radius = 0;
var initial_outside_radius = 0;
var changed_inside_radius = 0;
var changed_outside_radius = 0;

function makeFieldRequired(submitButton, requiredField) {
    $(submitButton).prop('disabled', true);
    $(requiredField).keyup(function() {
        if($(this).val() != '') {
            $(submitButton).prop('disabled', false);
        }
    });
}

function findProjectsForClient () {
    var allProjects = JSON.parse($('#order-projects-id-client-id').text());
    var selectedProject = $('#Order_project_id option:selected');
    var projectsToShow = [{id: '', text: '[ Выбрать проект ]'}];
    var selectedClientId = $('#Order_client_id option:selected').val();
    if (!selectedClientId) {
        selectedClientId = $('#Order_client_id').val();
    }
    $.each(allProjects, function(key, data){
        if (selectedClientId == data['client_id']) {
            projectsToShow.push({id: data['id'], text: data['title']});
        }
    });
    $('#Order_project_id').select2().empty();
    $('#Order_project_id').removeClass('select2-offscreen').select2({
        data: projectsToShow,
        placeholder: "[ Выбрать проект ]",
        allowClear: true
    });
    if (selectedProject.val()) {
        $('#Order_project_id').val(selectedProject.val()).trigger('change');
    }
}

$(function() {
    $('.autochangestatus').click(function () {
        if (confirm("Автоматически распределить заявки?")) {
            var url = $('.base_url').attr('href') + '/order/autoChangeStatus';
            $.get(url, function (result) {
                alert("Успешно!");
            });
        }
    });
});